<template>
    <div>
    <h2 class="mt-1 ml-15 hidden-sm-and-down grey--text">Reportes</h2> <!-- Full Screen -->
    <h3 class="mt-1 hidden-sm-and-up grey--text">Reportes</h3> <!-- Mobile Screen -->
        <v-card class="mt-5" dark>
            <v-card-subtitle class="blue_corp">
                <v-row class="mt-1">
                    <v-col cols="12" md="3">
                        <v-select @change="limpiaTable()" class='text-caption' v-model="tipo" :items="tipoReporte" label="Tipo Reporte" dense outlined></v-select>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date1" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined :disabled="disabledfecha"></v-text-field>
                            </template>
                            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date2" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined :disabled="disabledfecha"></v-text-field>
                            </template>
                            <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn @click="verReporte(tipo)" class="mt-1" small color="white" rounded><v-icon small class="blue--text">search</v-icon></v-btn>
                        <a v-if="descargaCSV===false" href="javascript:void(0)" @click="listaCSV(tipo)" style="text-decoration: none">
                            <v-btn class="mt-1 ml-2" small color="white" rounded><img valign="middle" src="@/assets/csv.png" width="16px" height="20px"/></v-btn>
                        </a>
                        <a v-else :href="descarga" style="text-decoration: none">
                            <v-btn class="mt-1 ml-2" small color="white" rounded><v-icon class="blue_corp--text">cloud_download</v-icon></v-btn>
                        </a>
                    </v-col>
                </v-row>
            </v-card-subtitle>
            <v-divider color="white"></v-divider>
            <v-card-text>
                <v-data-table :search="likesearch" :headers="headers" :items="itemsResult" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer class="elevation-1 text-size" @page-count="pageCount = $event">
                    <template v-slot:item.ruta="{ item }">
                        <div v-if="sigla=='INV'">
                            <a target="_blank" :href="item.ruta"><v-icon class="white--text" small >print</v-icon></a>
                        </div>
                        <div v-if="sigla=='NDV'">
                            <v-icon v-if="tipo=='Ventas' || tipo=='Devoluciones'" @click="imprimirPDF(item)" color="white" small>print</v-icon>
                            <v-icon v-else-if="tipo=='Cotizaciones'" @click="cotizaPDF(item)" color="white" small>print</v-icon>
                            <a v-else target="_blank" :href="item.ruta"><v-icon class="white--text" small >print</v-icon></a>
                        </div>
                    </template>
                    <template v-slot:item.detalle="{ item }">
                        <v-btn @click="verDetalle(tipo,item)" dark text><v-icon class="white--text" small >description</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-pagination v-model="page" :length="pageCount" total-visible="10"></v-pagination>
                    </v-col>
                    <v-col cols="10" md="4">
                        <v-text-field class='ml-5 mr-2 text-caption' v-model="likesearch" label="Buscar Dato" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <!-- dialogo detalle -->
        <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="dialog=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table dark :search="likesearchDialog" :headers="headersDetalle" :items="itemsDetalle" :page.sync="pageDialog" :items-per-page="itemsPerPageDialog" hide-default-footer class="elevation-1 text-size" @page-count="pageCountDialog = $event">
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-pagination v-model="pageDialog" :length="pageCountDialog" total-visible="10"></v-pagination>
                    </v-col>
                    <v-col cols="10" md="4">
                        <v-text-field class='ml-5 mr-2 text-caption' v-model="likesearchDialog" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <img id="logo_emisor" src="" height="0" width="0"> 

        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"/>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 8pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import { jsPDF } from "jspdf";
import PDF417 from '../pdf417-min';
import axios from 'axios';
export default {
    name: 'Reportes',
    components:{dialogo, snack},
    props: ['usu','contrato'],
    data(){
        return{
            fullReport:false,
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            tipo:'',
            tipoReporte:[],
            headers: [],
            items: [],
            headersDetalle: [],
            itemsDetalle: [],
            dialog:false,
            itemsResult: [],
            likesearch:'',
            page: 1,
            pageCount: 0,
            itemsPerPage: 8,
            likesearchDialog:'',
            pageDialog: 1,
            pageCountDialog: 0,
            itemsPerPageDialog: 10,
            menu1:false,
            date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu2:false,
            date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            descarga:'javascript:void(0)',
            descargaCSV:false,
            disabledfecha:false,
            //utilidades
            codigos:[],
            entradas:[],
            salidas:[],
            medidas:[],
            //Utilidad Final
            productos:[],
            movimientos:[],
            ganancias:[],
            totalgroup:[],
            sigla:'',
            office:0,

        }
    },
    async mounted(){
        this.sigla=this.contrato.substring(0,3).toUpperCase();
        await this.entrada();
    },
    methods: {
        async listaCSV(tipo){
            if (this.items.length!=0){
                await this.csvReporte(tipo);
                this.descargaCSV=true;
            }
        },
        limpiaTable(){
            this.headers= [];
            this.items= [];
            this.headersDetalle= [];
            this.itemsDetalle= [];
            this.itemsResult= [];
            this.descargaCSV=false;
            this.descarga='javascript:void(0)';
            //console.log(this.tipo);
             if(this.tipo=='Stock Critico' || 
                this.tipo=='Proveedores' ||
                this.tipo=='Clientes' ||
                this.tipo=='Usuarios' ||
                this.tipo=='Credito Cobranza' ||
                this.tipo=='Lista de Precios') {
                    this.disabledfecha=true;
             } else { this.disabledfecha=false }
        },
        async entrada(){
            this.loading=true;
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+ this.contrato +'/'+ this.usu);
            const datos=response.data;
            this.tipoReporte=[];
            if (datos[0].existe=='si'){
                this.office=datos[0].Sucursal;
                if (datos[0].Reporte!=0){
                    this.fullReport=true
                    this.tipoReporte.push('Stock Critico');
                    //this.tipoReporte.push('Utilidad');
                    this.tipoReporte.push('Utilidades x Producto');
                    this.tipoReporte.push('Credito Cobranza');
                    this.tipoReporte.push('Lista de Precios');
                    // this.tipoReporte.push('Libro de Ventas');
                } else {
                    this.fullReport=false
                };
                if(datos[0].Permiso_4_2!=0 || datos[0].Permiso_4_3!=0) {
                    this.tipoReporte.push('Productos')
                }; 
                if(datos[0].Permiso_3_1!=0) {
                    this.tipoReporte.push('Compras')
                };
                if(datos[0].Permiso_3_3!=0) {
                    this.tipoReporte.push('Cotizaciones');
                    this.tipoReporte.push('Comisiones')
                }; 
                if(datos[0].Permiso_3_2!=0) {
                    this.tipoReporte.push('Ventas')
                }; 
                if(datos[0].Permiso_3_4!=0) {
                    this.tipoReporte.push('Devoluciones')
                }; 
                if(datos[0].Permiso_6_1!=0) {
                    this.tipoReporte.push('Proveedores')
                }; 
                if(datos[0].Permiso_6_2!=0) {
                    this.tipoReporte.push('Clientes')
                }; 
                if(datos[0].Permiso_6_3!=0) {
                    this.tipoReporte.push('Usuarios')
                }; 
                if(datos[0].Permiso_1_2!=0) {
                    this.tipoReporte.push('Orden de Trabajo');
                }; 
            }
            this.loading=false; 
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        async verDetalle(tipo,array){
            this.headersDetalle=[];
            this.itemsDetalle=[];
            let response;
            let datos;
            switch (tipo) {
                case 'Comisiones':
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/detalle/dte/'+this.contrato+'/'+array.orden);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.headersDetalle=[
                            { text: 'Fecha Dte', align: 'start', sortable: true, value: 'fecha' },
                            { text: 'N° Dte', align: 'start', sortable: true, value: 'numero' },
                            { text: 'Tipo Dte', align: 'start', sortable: true, value: 'tipo' },
                            { text: 'Neto', align: 'center', sortable: true, value: 'neto' },
                        ];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            this.itemsDetalle.push({
                                'fecha':element.Fecha,
                                'numero':element.Numero,
                                'tipo':element.Tipo,
                                'neto':new Intl.NumberFormat("de-DE").format(parseFloat(element.Neto)),
                            })        
                        }
                    }
                break
                case 'Compras':
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/app3/C/'+this.contrato+'/'+array.numero+'/'+array.entidad);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.headersDetalle=[
                            { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                            { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                            { text: 'Precio Neto', align: 'center', sortable: true, value: 'neto' },
                            { text: 'Precio +iva', align: 'center', sortable: true, value: 'precio' },
                            { text: 'Cantidad', align: 'center', sortable: true, value: 'cantidad' },
                            { text: 'Medida', align: 'center', sortable: true, value: 'medida' },
                            { text: 'Bodega', align: 'start', sortable: true, value: 'bodega' },
                            { text: 'Observacion', align: 'start', sortable: true, value: 'observa' },
                        ];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            this.itemsDetalle.push({
                                'sku':element.Sku,
                                'producto':element.Producto,
                                'neto':new Intl.NumberFormat("de-DE").format(parseFloat(element.Neto)),
                                'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                                'cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                                'medida':element.Medida,
                                'bodega':element.Bodega,
                                'observa':element.Observa,
                            })        
                        }
                    }
                break
                case 'Cotizaciones':
                    //console.log(array);
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/app3/V/'+this.contrato+'/'+array.orden+'/'+array.entidad);
                    datos=response.data;
                    //console.log(datos);
                    if (datos[0].existe=='si'){
                        this.headersDetalle=[
                            { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                            { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                            { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
                            { text: 'cantidad', align: 'center', sortable: true, value: 'cantidad' },
                            { text: 'Medida', align: 'center', sortable: true, value: 'medida' },
                            { text: 'Bodega', align: 'center', sortable: true, value: 'bodega' },
                            { text: 'Observacion', align: 'start', sortable: true, value: 'observa' },
                        ];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            this.itemsDetalle.push({
                                'sku':element.Sku,
                                'producto':element.Producto,
                                'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                                'cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                                'medida':element.Medida,
                                'bodega':element.Bodega,
                                'observa':element.Observa,
                            })        
                        }
                    }
                break
                case 'Ventas':
                    //console.log(array);
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/app3/V/'+this.contrato+'/'+array.orden+'/'+array.entidad);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.headersDetalle=[
                            { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                            { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                            { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
                            { text: 'cantidad', align: 'center', sortable: true, value: 'cantidad' },
                            { text: 'Medida', align: 'center', sortable: true, value: 'medida' },
                            { text: 'Bodega', align: 'center', sortable: true, value: 'bodega' },
                        ];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            this.itemsDetalle.push({
                                'sku':element.Sku,
                                'producto':element.Producto,
                                'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                                'cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                                'medida':element.Medida,
                                'bodega':element.Bodega,
                            })        
                        }
                    }
                break
                case 'Devoluciones':
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/app3/D/'+this.contrato+'/'+array.numero+'/'+array.entidad);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.headersDetalle=[
                            { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                            { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                            { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
                            { text: 'cantidad', align: 'center', sortable: true, value: 'cantidad' },
                            { text: 'Medida', align: 'center', sortable: true, value: 'medida' },
                            { text: 'Bodega', align: 'center', sortable: true, value: 'bodega' },
                        ];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            if(parseFloat(element.Cantidad)!=0){
                                this.itemsDetalle.push({
                                    'sku':element.Sku,
                                    'producto':element.Producto,
                                    'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                                    'cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                                    'medida':element.Medida,
                                    'bodega':element.Bodega,
                                })        
                            }
                        }
                    }
                break
            }
            this.dialog=true;
        },
        async csvReporte(tipo){
            this.loading=true;
            this.descarga='javascript:void(0)';
            var date = new Date();
            const formatDate = (current_datetime)=>{
                let formatted_date = current_datetime.getFullYear() + "" + (current_datetime.getMonth() + 1) + "" + current_datetime.getDate() + "" + current_datetime.getHours() + "" + current_datetime.getMinutes() + "" + current_datetime.getSeconds();
                return formatted_date;
            };
            const nameFile = tipo+'_'+formatDate(date);
            let csv;
            csv=[];
            let params;
            let response;
            //console.log(tipo);
            switch (tipo) {
                case 'Orden de Trabajo':
                        //titulo
                        csv.push({
                            'fecha':'Fecha',
                            'ot':'N° OT',
                            'rut':'Rut',
                            'cliente':'Cliente',
                            'placa':'Placa Patente',
                            'marca':'Marca',
                            'modelo':'Modelo',
                            'color':'Color',
                            'anio':'Año',
                            'total':'Total',
                            'nv':'Nota de Venta'
                        });
                        //datos
                        this.itemsResult.forEach(element => {
                            csv.push({
                                'fecha':element.fecha,
                                'ot':element.ot,
                                'rut':element.rut,
                                'cliente':element.cliente,
                                'placa':element.placa,
                                'marca':element.marca,
                                'modelo':element.modelo,
                                'color':element.color,
                                'anio':element.anio,
                                'total':element.total,
                                'nv':element.nv
                            })
                        });
                        params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                        response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                        if (response.data=='si'){
                            this.descarga=process.env.VUE_APP_URL +'/buzon/'+this.contrato+'/'+nameFile+'.csv';
                        }
                    break
                case 'Comisiones':
                        //titulo
                        csv.push({
                            'fecha':'Fecha',
                            'orden':'Orden',
                            'usuario':'Usuario',
                            'total':'Total',
                            'porciento':'(%) Comision',
                            'comision':'Comision ($)'
                        });
                        //datos
                        this.itemsResult.forEach(element => {
                            csv.push({
                                'fecha':element.fecha,
                                'orden':element.orden,
                                'usuario':element.usuario,
                                'total':element.total,
                                'porciento':element.porciento,
                                'comision':element.comision
                            })
                        });
                        params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                        response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                        if (response.data=='si'){
                            this.descarga=process.env.VUE_APP_URL +'/buzon/'+this.contrato+'/'+nameFile+'.csv';
                        }
                    break
                    case 'Utilidades x Producto':
                        //titulo
                        csv.push({
                            'Fecha':'Fecha',
                            'Sku':'Sku',
                            'Producto':'Producto',
                            'Cantidad':'Cantidad',
                            'Precio Compra':'PrecioCompra',
                            'Precio Venta':'PrecioVenta',
                            'Utilidad':'Utilidad',
                            'Bodega':'Bodega',
                            'Origen':'Origen'
                        });
                        //datos
                        this.itemsResult.forEach(element => {
                            csv.push({
                                'Fecha':element.Fecha,
                                'Sku':element.Sku,
                                'Producto':element.Producto,
                                'Cantidad':element.Cantidad,
                                'PrecioCompra':element.PrecioCompra,
                                'PrecioVenta':element.PrecioVenta,
                                'Utilidad':element.Utilidad,
                                'Bodega':element.Bodega,
                                'Origen':element.Origen
                            })
                        });
                        params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                        response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                        if (response.data=='si'){
                            this.descarga=process.env.VUE_APP_URL +'/buzon/'+this.contrato+'/'+nameFile+'.csv';
                        }
                    break
                    case 'Utilidad':
                        //titulo
                        csv.push({
                            'fecha':'Fecha',
                            'sku':'Sku',
                            'producto':'Producto',
                            'cantidad':'Cantidad',
                            'compra':'Compra (u)',
                            'venta':'Venta (u)',
                            'diferencia':'Total',
                            'impuesto':'Impuesto',
                            'utilidad':'Utilidad',
                            'sucursal':'Bodega'
                        });
                        //datos
                        this.itemsResult.forEach(element => {
                            csv.push({
                                'fecha':element.fecha,
                                'sku':element.sku,
                                'producto':element.producto,
                                'cantidad':element.cantidad,
                                'compra':element.compra,
                                'venta':element.venta,
                                'diferencia':element.diferencia,
                                'impuesto':element.impuesto,
                                'utilidad':element.utilidad,
                                'sucursal':element.sucursal
                            })
                        });
                        params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                        response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                        if (response.data=='si'){
                            this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                        }
                    break
                case 'Stock Critico':
                    //titulo
                    csv.push({
                        'sku':'Sku',
                        'producto':'Producto',
                        'bodega':'Bodega',
                        'stock':'Stock',
                        'medida':'Medida',
                        'u12m':'U12M',
                        'pu12m':'PU12M',
                        'u30d':'U30D',
                        'u90d':'U90D',
                        'p3m':'P3M',
                        'critico':'Critico'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'sku':element.sku,
                            'producto':element.producto,
                            'bodega':element.bodega,
                            'stock':element.stock,
                            'medida':element.medida,
                            'u12m':element.u12m,
                            'pu12m':element.pu12m,
                            'u30d':element.u30d,
                            'u90d':element.u90d,
                            'p3m':element.p3m,
                            'critico':element.critico
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Productos':
                    //titulo
                    csv.push({
                        'fecha':'Fecha',
                        'sku':'Sku',
                        'producto':'Producto',
                        'movimiento':'Movimiento',
                        'entidad':'Entidad',
                        'cantidad':'Cantidad',
                        'medida':'Medida',
                        'precio':'Precio',
                        'bodega':'Bodega',
                        'usuario':'Usuario',
                        'observa':'Observa'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'fecha':element.fecha,
                            'sku':element.sku,
                            'producto':element.producto,
                            'movimiento':element.movimiento,
                            'entidad':element.entidad,
                            'cantidad':element.cantidad,
                            'medida':element.medida,
                            'precio':element.precio,
                            'bodega':element.bodega,
                            'usuario':element.usuario,
                            'observa':element.observa
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Compras':
                    //titulo
                    csv.push({
                        'emision':'Emision',
                        'fecha':'Ingreso',
                        'vencimiento':'Vencimiento',
                        'proveedor':'Proveedor',
                        'numero':'Numero',
                        'pago':'Pago',
                        'productos':'Productos',
                        'total':'Total',
                        // 'exenta':'Exenta',
                        'usuario':'Usuario'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'fecha':element.emision,
                            'fecha':element.fecha,
                            'vencimiento':element.vencimiento,
                            'proveedor':element.proveedor,
                            'numero':element.numero,
                            'pago':element.pago,
                            'productos':element.productos,
                            'total':element.total,
                            // 'exenta':element.exenta,
                            'usuario':element.usuario
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Cotizaciones':
                    //titulo
                    csv.push({
                        'fecha':'Fecha',
                        'orden':'Orden',
                        'productos':'Productos',
                        'total':'Total',
                        'usuario':'Usuario'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'fecha':element.fecha,
                            'orden':element.orden,
                            'productos':element.productos,
                            'total':element.total,
                            'usuario':element.usuario
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Ventas':
                    //titulo
                    csv.push({
                        'fecha':'Fecha',
                        'vencimiento':'Vencimiento',
                        'cliente':'Cliente',
                        'tipo':'Documento',
                        'numero':'Numero',
                        'orden':'Orden',
                        'total':'Total',
                        'pago':'Pago',
                        'usuario':'Usuario',
                        'comision':'Comision',
                        'sucursal':'Bodega',
                        'oficina':'Sucursal'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'fecha':element.fecha,
                            'vencimiento':element.vencimiento,
                            'cliente':element.cliente,
                            'tipo':element.tipo,
                            'numero':element.numero,
                            'orden':element.orden,
                            'total':element.total,
                            'pago':element.pago,
                            'usuario':element.usuario,
                            'comision':element.comision,
                            'sucursal':element.sucursal,
                            'oficina':element.oficina
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Devoluciones':
                    //titulo
                    csv.push({
                        'fecha':'Fecha',
                        'cliente':'Cliente',
                        'tipo':'Documento',
                        'numero':'Numero',
                        'orden':'N.Orden',
                        'venta':'N.Venta',
                        'total':'Total',
                        'pago':'Pago',
                        'usuario':'Usuario',
                        'sucursal':'Bodega',
                        'oficina':'Sucursal'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'fecha':element.fecha,
                            'cliente':element.cliente,
                            'tipo':element.tipo,
                            'numero':element.numero,
                            'orden':element.orden,
                            'venta':element.venta,
                            'total':element.total,
                            'pago':element.pago,
                            'usuario':element.usuario,
                            'sucursal':element.sucursal,
                            'oficina':element.oficina
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Proveedores':
                    //titulo
                    csv.push({
                        'rut':'Rut',
                        'nombre':'Nombre',
                        'email':'Email',
                        'ciudad':'Ciudad',
                        'estado':'Estado',
                        'observa':'Observacion'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'rut':element.rut,
                            'nombre':element.nombre,
                            'email':element.email,
                            'ciudad':element.ciudad,
                            'estado':element.estado,
                            'observa':element.observa
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Clientes':
                    //titulo
                    csv.push({
                        'rut':'Rut',
                        'nombre':'Nombre',
                        'alias':'Alias',
                        'email':'Email',
                        'ciudad':'Ciudad',
                        'estado':'Vigente',
                        'vendedor':'Vendedor',
                        'observa':'Observacion'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'rut':element.rut,
                            'nombre':element.nombre,
                            'alias':element.alias,
                            'email':element.email,
                            'ciudad':element.ciudad,
                            'estado':element.estado,
                            'vendedor':element.vendedor,
                            'observa':element.observa
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Usuarios':
                    //titulo
                    csv.push({
                        'login':'Login',
                        'nombre':'Nombre',
                        'email':'Email',
                        'comision':'Comision',
                        'local':'Bodega',
                        'estado':'Estado'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'login':element.login,
                            'nombre':element.nombre,
                            'email':element.email,
                            'comision':element.comision,
                            'local':element.local,
                            'estado':element.estado
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Credito Cobranza':
                    //titulo
                    csv.push({
                        'emision':'Emision',
                        'vencimiento':'Vencimiento',
                        'rut':'Rut',
                        'nombre':'Nombre',
                        'documento':'Documento',
                        'numero':'Numero',
                        'total':'Total',
                        'cuenta':'Credito',
                        'estado':'Estado',
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'emision':element.emision,
                            'vencimiento':element.vencimiento,
                            'rut':element.rut,
                            'nombre':element.nombre,
                            'documento':element.documento,
                            'numero':element.numero,
                            'total':element.total,
                            'cuenta':element.cuenta,
                            'estado':element.estado
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Lista de Precios':
                    //titulo
                    csv.push({
                        'sku':'Sku',
                        'producto':'Producto',
                        'marca':'Marca',
                        'categoria':'Categoria',
                        'caracteristica':'Caracteristica',
                        'descripcion':'Descripcion',
                        'medida':'Unidad Medida',
                        'barra':'Cod. Barra',
                        'universal':'Cod. Universal',
                        'local':'Precio Local',
                        'mayor':'Precio Mayor',
                        'oferta':'Precio Oferta',
                        //'critico':'Stock Critico',
                        'estado':'Estado',
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'sku':element.sku,
                            'producto':element.producto,
                            'marca':element.marca,
                            'categoria':element.categoria,
                            'caracteristica':element.caracteristica,
                            'descripcion':element.descripcion,
                            'medida':element.medida,
                            'barra':element.barra,
                            'universal':element.universal,
                            'local':element.local,
                            'mayor':element.mayor,
                            'oferta':element.oferta,
                            //'critico':element.critico,
                            'estado':element.estado,
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
                case 'Libro de Ventas':
                    //titulo
                    csv.push({
                        'fecha':'Rut',
                        'documento':'Documento',
                        'numero':'Numero',
                        'neto':'Neto',
                        'iva':'Iva',
                        'total':'Total',
                        'pago':'Pago',
                        'sucursal':'Sucursal'
                    });
                    //datos
                    this.itemsResult.forEach(element => {
                        csv.push({
                            'fecha':element.fecha,
                            'documento':element.documento,
                            'numero':element.numero,
                            'neto':element.neto,
                            'iva':element.iva,
                            'total':element.total,
                            'pago':element.pago,
                            'sucursal':element.sucursal
                        })
                    });
                    params = {'datos':csv,'contrato':this.contrato,'archivo':nameFile};
                    response = await axios.post(process.env.VUE_APP_URL + '/api/inv/csv/nuevo',params);
                    if (response.data=='si'){
                        this.descarga=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+nameFile+'.csv';
                    }
                break
            }
            this.loading=false;
        },
        async verReporte(tipo){
            this.descarga='javascript:void(0)';
            this.descargaCSV=false;
            this.likesearch='';
            this.page=1;
            this.likesearchDialog='';
            this.pageDialog= 1;
            this.loading=true;
            let response;
            let datos;
            if (tipo!=''){
                switch (tipo) {
                    case 'Orden de Trabajo':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Orden Trabajo', align: 'center', sortable: true, value: 'ot' },
                        { text: 'Rut', align: 'start', sortable: false, value: 'rut' },
                        { text: 'Cliente', align: 'center', sortable: true, value: 'cliente' },
                        { text: 'Marca', align: 'start', sortable: false, value: 'marca' },
                        { text: 'Modelo', align: 'start', sortable: false, value: 'modelo' },
                        { text: 'Color', align: 'center', sortable: false, value: 'color' },
                        { text: 'Año', align: 'center', sortable: false, value: 'anio' },
                        { text: 'Total', align: 'center', sortable: false, value: 'total' },
                        { text: 'Nota de Venta', align: 'center', sortable: false, value: 'nv' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/ot/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    console.log('OT', datos);
                    if (datos[0].existe=='si'){
                        this.items= [];
                        datos.forEach(element => {
                            this.items.push({
                                'fecha':element.Fecha,
                                'ot':element.OT,
                                'rut':element.Rut,
                                'cliente':element.Nombre,
                                'marca':element.Marca,
                                'modelo':element.Modelo,
                                'color':element.Color,
                                'anio':element.Anio,
                                'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                                'nv':element.Orden,
                            })
                        });
                    }
                    break
                    case 'Comisiones':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Orden', align: 'center', sortable: true, value: 'orden' },
                        { text: 'Usuario', align: 'start', sortable: false, value: 'usuario' },
                        { text: 'Total', align: 'center', sortable: true, value: 'total' },
                        { text: '(%) Comision', align: 'start', sortable: false, value: 'porciento' },
                        { text: 'Comision ($)', align: 'start', sortable: false, value: 'comision' },
                        { text: 'Detalle', align: 'center', sortable: false, value: 'detalle' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/comisiones/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.items= [];
                        datos.forEach(element => {
                            const myComision=(parseFloat(element.Comision)*parseFloat(element.Total))/100;
                            this.items.push({
                                'fecha':element.Fecha,
                                'orden':element.Orden,
                                'usuario':element.Usuario,
                                'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                                'porciento':new Intl.NumberFormat("de-DE").format(parseFloat(element.Comision)),
                                'comision':new Intl.NumberFormat("de-DE").format(parseFloat(myComision)),
                            })
                        });
                    }
                    break
                    case 'Lista de Precios':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                        { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                        { text: 'Categoria', align: 'start', sortable: true, value: 'categoria' },
                        { text: 'Marca', align: 'start', sortable: true, value: 'marca' },
                        { text: 'Caracteristica', align: 'start', sortable: false, value: 'caracteristica' },
                        //{ text: 'Descripcion', align: 'start', sortable: false, value: 'descripcion' },
                        { text: 'Medida', align: 'start', sortable: false, value: 'medida' },
                        { text: 'Cod. Barra', align: 'start', sortable: false, value: 'barra' },
                        { text: 'Cod. Universal', align: 'start', sortable: true, value: 'universal' },
                        { text: 'Precio Local', align: 'start', sortable: false, value: 'local' },
                        { text: 'Precio Mayor', align: 'center', sortable: false, value: 'mayor' },
                        { text: 'Precio Oferta', align: 'start', sortable: false, value: 'oferta' },
                        //{ text: 'Critico', align: 'start', sortable: false, value: 'critico' },
                        { text: 'Estado', align: 'start', sortable: false, value: 'estado' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/lista/productos/'+this.contrato);
                    datos=response.data;
                    //console.log(datos);
                    if (datos[0].existe=='si'){
                        this.items= [];
                        datos.forEach(element => {
                            let critical='NO';
                            if(element.Critico!=0){
                                critical='SI';
                            }
                            this.items.push({
                                'sku':element.Sku,
                                'producto':element.Nombre,
                                'categoria':element.CategoriaName,
                                'marca': element.Marca,
                                'caracteristica':element.Caracteristica,
                                'descripcion':element.Descripcion,
                                'medida':element.Medida,
                                'barra':element.Barra,
                                'universal':element.Universal,
                                'local':new Intl.NumberFormat("de-DE").format(parseFloat(element.PrecioLocal)),
                                'mayor':new Intl.NumberFormat("de-DE").format(parseFloat(element.PrecioMayor)),
                                'oferta':new Intl.NumberFormat("de-DE").format(parseFloat(element.PrecioOferta)),
                                'critico':element.Critico,
                                'estado':element.Estado,
                            })
                        });
                    }
                  break
                  case 'Credito Cobranza':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Emision', align: 'start', sortable: true, value: 'emision' },
                        { text: 'Vencimiento', align: 'start', sortable: true, value: 'vencimiento' },
                        { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
                        { text: 'Nombre', align: 'start', sortable: true, value: 'nombre' },
                        { text: 'Documento', align: 'start', sortable: false, value: 'documento' },
                        { text: 'Numero', align: 'start', sortable: false, value: 'numero' },
                        { text: 'Total ($)', align: 'start', sortable: true, value: 'total' },
                        { text: 'Credito', align: 'start', sortable: true, value: 'cuenta' },
                        { text: 'Estado', align: 'start', sortable: true, value: 'estado' }
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/credito/cobranza/'+this.contrato);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.items= [];
                        var vence='';
                        var status='--';
                        const hoy=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
                        datos.forEach(element => {
                            if(parseFloat(element.TipoDte)==2){ 
                                vence='--';
                                status=element.Estado
                            }else { 
                                vence=element.Vencimiento;
                                if(new Date(element.Vencimiento)<new Date(hoy) && element.Estado=='Pendiente'){
                                    status='Vencido'
                                } else { status=element.Estado }
                            };
                            let txt_cuenta='';
                            if(element.Cuenta=='Pagar'){ txt_cuenta='Proveedores' };
                            if(element.Cuenta=='Cobrar'){ txt_cuenta='Clientes' };
                            this.items.push({
                                'emision':element.Fecha,
                                'vencimiento':vence,
                                'rut':element.Rut,
                                'nombre':element.Razon,
                                'documento':element.Documento,
                                'numero':element.Numero,
                                'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                                'cuenta':txt_cuenta,
                                'estado':status
                            })
                        });
                    }
                    break
                  case 'Utilidades x Producto':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'Fecha' },
                        { text: 'Sku', align: 'start', sortable: true, value: 'Sku' },
                        { text: 'Producto', align: 'start', sortable: true, value: 'Producto' },
                        { text: 'Cantidad', align: 'start', sortable: true, value: 'Cantidad' },
                        { text: 'Precio Compra', align: 'start', sortable: true, value: 'PrecioCompra' },
                        { text: 'Precio Venta', align: 'start', sortable: false, value: 'PrecioVenta' },
                        { text: 'Utilidad', align: 'start', sortable: false, value: 'Utilidad' },
                        { text: 'Bodega', align: 'start', sortable: false, value: 'Bodega' },
                        { text: 'Origen', align: 'start', sortable: false, value: 'Origen' },
                    ];
                    await this.rptGanancias();
                    //await this.Util();
                    break
                  case 'Utilidad':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Sku', align: 'left', sortable: true, value: 'sku' },
                        { text: 'Producto', align: 'left', sortable: true, value: 'producto' },
                        { text: 'Cantidad', align: 'start', sortable: false, value: 'cantidad' },
                        { text: 'Compra (u)', align: 'start', sortable: false, value: 'compra' },
                        { text: 'Venta (u)', align: 'start', sortable: false, value: 'venta' },
                        { text: 'Total', align: 'center', sortable: false, value: 'diferencia' },
                        { text: 'Impuesto', align: 'center', sortable: false, value: 'impuesto' },
                        { text: 'Utilidad', align: 'start', sortable: true, value: 'utilidad' },
                        { text: 'Bodega', align: 'start', sortable: true, value: 'sucursal' }
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/utilidad/detalle/v4/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        this.items= [];
                        datos.forEach(element => {
                            //console.log(element.Fecha,this.date1,this.date2);
                            if (element.Fecha>=this.date1 && element.Fecha<=this.date2 && element.Sucursal!='Reciclaje'){
                                //console.log(element.Fecha,this.date1);
                                const varDiferencia=parseFloat(element.Utilidad);
                                const varUtilidad=Math.round(parseFloat(varDiferencia)/(1+(parseFloat(element.Iva)/100)));
                                const varImpuesto=parseFloat(varDiferencia)-parseFloat(varUtilidad);
                                this.items.push({
                                    'fecha':element.Fecha,
                                    'sku':element.Sku,
                                    'producto':element.Producto,
                                    'cantidad':element.Cantidad,
                                    'compra':new Intl.NumberFormat("de-DE").format(parseFloat(element.Compra)),
                                    'venta':new Intl.NumberFormat("de-DE").format(parseFloat(element.Venta)),
                                    'diferencia':new Intl.NumberFormat("de-DE").format(parseFloat(varDiferencia)),
                                    'impuesto':new Intl.NumberFormat("de-DE").format(parseFloat(varImpuesto)),
                                    'utilidad':new Intl.NumberFormat("de-DE").format(parseFloat(varUtilidad)),
                                    'sucursal':element.Sucursal
                                })
                            } 
                        });
                    }
                    break
                  case 'Stock Critico':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Sku', align: 'left', sortable: true, value: 'sku' },
                        { text: 'Producto', align: 'left', sortable: true, value: 'producto' },
                        { text: 'Bodega', align: 'left', sortable: true, value: 'bodega' },
                        { text: 'Stock', align: 'start', sortable: false, value: 'stock' },
                        { text: 'Medida', align: 'start', sortable: false, value: 'medida' },
                        { text: 'U12M', align: 'start', sortable: false, value: 'u12m' },
                        { text: 'PU12M', align: 'start', sortable: false, value: 'pu12m' },
                        { text: 'U30D', align: 'center', sortable: false, value: 'u30d' },
                        { text: 'U90D', align: 'start', sortable: false, value: 'u90d' },
                        { text: 'P3M', align: 'start', sortable: false, value: 'p3m' },
                        { text: 'Critico', align: 'start', sortable: true, value: 'critico' }
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/calculostock/app3/'+this.contrato);
                    datos=response.data;
                    //console.log(datos);
                    if (datos[0].existe=='si'){
                        this.items= [];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            let critical='NO';
                            if(element.Critico!=0){
                                critical='SI';
                            }
                            this.items.push({
                                'sku':element.Sku,
                                'producto':element.Producto,
                                'bodega':element.Bodega,
                                'stock':new Intl.NumberFormat("de-DE").format(parseFloat(element.Stock)),
                                'medida':element.Medida,
                                'u12m':new Intl.NumberFormat("de-DE").format(parseFloat(element.U12M)),
                                'pu12m':new Intl.NumberFormat("de-DE").format(parseFloat(element.PU12M)),
                                'u30d':new Intl.NumberFormat("de-DE").format(parseFloat(element.U30D)),
                                'u90d':new Intl.NumberFormat("de-DE").format(parseFloat(element.U90D)),
                                'p3m':new Intl.NumberFormat("de-DE").format(parseFloat(element.P3M)),
                                'critico':critical
                            })
                        };
                    }
                    break
                  case 'Productos':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Sku', align: 'center', sortable: true, value: 'sku' },
                        { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                        { text: 'Movimiento', align: 'start', sortable: true, value: 'movimiento' },
                        { text: 'Entidad', align: 'start', sortable: false, value: 'entidad' },
                        { text: 'Cantidad', align: 'center', sortable: true, value: 'cantidad' },
                        { text: 'Medida', align: 'center', sortable: true, value: 'medida' },
                        { text: 'Precio', align: 'start', sortable: false, value: 'precio' },
                        { text: 'Bodega', align: 'start', sortable: false, value: 'bodega' },
                        { text: 'Usuario', align: 'start', sortable: false, value: 'usuario' },
                        { text: 'Observa', align: 'start', sortable: false, value: 'observa' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/productos/app3/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    //console.log(datos);
                    if (datos[0].existe=='si'){
                        this.items= [];
                        for (let index = 0; index < datos.length; index++) {
                            const element = datos[index];
                            this.items.push({
                                'fecha':element.Fecha,
                                'sku':element.Sku,
                                'producto':element.Producto,
                                'movimiento':element.Movimiento,
                                'entidad':element.Entidad,
                                'cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                                'medida':element.Medida,
                                'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                                'bodega':element.Bodega,
                                'usuario':element.Usuario,
                                'observa':element.Observa
                            })
                        }
                    }
                    break
                  case 'Compras':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Emision', align: 'center', sortable: true, value: 'emision' },
                        { text: 'Ingreso', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Vencimiento', align: 'center', sortable: true, value: 'vencimiento' },
                        { text: 'Proveedor', align: 'start', sortable: true, value: 'proveedor' },
                        { text: 'Numero', align: 'center', sortable: true, value: 'numero' },
                        { text: 'Pago', align: 'center', sortable: true, value: 'pago' },
                        { text: 'Productos', align: 'center', sortable: true, value: 'productos' },
                        { text: 'Total', align: 'center', sortable: true, value: 'total' },
                        //{ text: 'Exenta', align: 'center', sortable: true, value: 'exenta' },
                        { text: 'Usuario', align: 'start', sortable: false, value: 'usuario' },
                        { text: 'Detalle', align: 'center', sortable: false, value: 'detalle' },
                        { text: 'Ver', align: 'center', sortable: false, value: 'ruta' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/cc/v4/C/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            if (parseFloat(element.Productos)!=0){
                                let html=process.env.VUE_APP_URL + '/api/inv/prt/compra/v4/'+this.contrato+'/'+element.Orden+'/'+element.Entidad;
                                //calculamos el total de la compra con iva
                                const varIva=parseFloat(element.Total)*(parseFloat(element.Iva)/100);
                                const varTotal=Math.round(parseFloat(element.Total)+varIva);
                                this.items.push({
                                    'entidad':element.Entidad,
                                    'emision':element.Emision,
                                    'fecha':element.Fecha,
                                    'vencimiento':element.Fecha_Pago,
                                    'proveedor':element.Proveedor,
                                    'numero':element.Orden,
                                    'pago':element.Forma_Pago,
                                    'productos':element.Productos,
                                    'total':new Intl.NumberFormat("de-DE").format(parseFloat(varTotal)),
                                    'exenta':element.Exenta,
                                    'usuario':element.Usuario,
                                    'ruta':html
                                })
                            }
                        });
                    }
                    break
                  case 'Cotizaciones':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Orden', align: 'center', sortable: true, value: 'orden' },
                        { text: 'Cliente', align: 'start', sortable: true, value: 'cliente' },
                        { text: 'Productos', align: 'center', sortable: true, value: 'productos' },
                        { text: 'Total', align: 'center', sortable: true, value: 'total' },
                        { text: 'Usuario', align: 'start', sortable: false, value: 'usuario' },
                        { text: 'Detalle', align: 'start', sortable: false, value: 'detalle' },
                        { text: 'Ver', align: 'start', sortable: false, value: 'ruta' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/cotiza/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    console.log('datos cotiza',datos);
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            if (parseFloat(element.Productos)!=0){
                                let html=process.env.VUE_APP_URL + '/api/inv/prt/cotiza/v4/'+this.contrato+'/'+element.Orden+'/'+element.Entidad; 
                                this.items.push({
                                    'entidad':element.Entidad,
                                    'fecha':element.Fecha,
                                    'orden':element.Orden,
                                    'cliente':element.Cliente,
                                    'productos':element.Productos,
                                    'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                                    'usuario':element.Usuario,
                                    'ruta':html
                                })
                            }
                        });
                    }
                    break
                  case 'Ventas':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Vencimiento', align: 'center', sortable: true, value: 'vencimiento' },
                        { text: 'Cliente', align: 'start', sortable: true, value: 'cliente' },
                        { text: 'Documento', align: 'start', sortable: true, value: 'tipo' },
                        { text: 'Numero', align: 'center', sortable: true, value: 'numero' },
                        { text: 'Orden', align: 'center', sortable: true, value: 'orden' },                        
                        { text: 'Total', align: 'center', sortable: true, value: 'total' },
                        { text: 'Pago', align: 'start', sortable: true, value: 'pago' },
                        { text: 'Usuario', align: 'start', sortable: false, value: 'usuario' },
                        { text: 'Comision', align: 'center', sortable: false, value: 'comision' },
                        { text: 'Bodega', align: 'start', sortable: true, value: 'sucursal' },
                        { text: 'Sucursal', align: 'start', sortable: true, value: 'oficina' },
                        { text: 'Detalle', align: 'center', sortable: false, value: 'detalle' },
                        { text: 'Ver', align: 'center', sortable: false, value: 'ruta' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/dte/v4/in/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    console.log(datos)
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            this.items.push({
                                'entidad':element.Entidad,
                                'fecha':element.Fecha,
                                'vencimiento':element.Vencimiento,
                                'cliente':element.Cliente,
                                'tipo':element.Documento,
                                'numero':element.Numero,
                                'orden':element.Orden,
                                'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                                'pago':element.Forma,
                                'usuario':element.Usuario,
                                'comision':element.Comision,
                                'sucursal':element.Suc,
                                'oficina':element.Office,

                                'ruta':element.RutaPdf
                            })
                        });
                    }                      
                    break
                  case 'Devoluciones':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Cliente', align: 'center', sortable: true, value: 'cliente' },
                        { text: 'Documento', align: 'start', sortable: true, value: 'tipo' },
                        { text: 'Numero', align: 'center', sortable: true, value: 'numero' },
                        { text: 'N° Orden', align: 'center', sortable: true, value: 'orden' },
                        { text: 'N° Venta', align: 'center', sortable: true, value: 'venta' },                        
                        { text: 'Total', align: 'center', sortable: true, value: 'total' },
                        { text: 'Pago', align: 'center', sortable: true, value: 'pago' },
                        { text: 'Usuario', align: 'start', sortable: false, value: 'usuario' },
                        { text: 'Bodega', align: 'start', sortable: true, value: 'sucursal' },
                        { text: 'Sucursal', align: 'start', sortable: true, value: 'oficina' },
                        { text: 'Detalle', align: 'start', sortable: false, value: 'detalle' },
                        { text: 'Ver', align: 'start', sortable: false, value: 'ruta' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/dte/v4/out/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            this.items.push({
                                'entidad':element.Entidad,
                                'fecha':element.Fecha,
                                'cliente':element.Cliente,
                                'tipo':element.Documento,
                                'numero':element.Numero,
                                'orden':element.Orden,
                                'venta':element.nVenta,
                                'total':new Intl.NumberFormat("de-DE").format(parseFloat(element.Total)),
                                'pago':element.Forma,
                                'usuario':element.Usuario,
                                'sucursal':element.Suc,
                                'oficina':element.Office,
                                'ruta':element.RutaPdf
                            })
                        });
                    }                      
                    break
                  case 'Proveedores':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
                        { text: 'Nombre', align: 'start', sortable: true, value: 'nombre' },
                        { text: 'Email', align: 'start', sortable: true, value: 'email' },
                        { text: 'Ciudad', align: 'start', sortable: true, value: 'ciudad' },
                        { text: 'Vigente', align: 'center', sortable: false, value: 'estado' },
                        { text: 'Observacion', align: 'start', sortable: false, value: 'observa' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/entidad/Proveedor/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            this.items.push({
                                'rut':element.Rut,
                                'nombre':element.Razon,
                                'email':element.Email,
                                'ciudad':element.Ciudad,
                                'estado':element.Estado,
                                'observa':element.Observa
                            })
                        });
                    }                      
                    break
                  case 'Clientes':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
                        { text: 'Nombre', align: 'start', sortable: true, value: 'nombre' },
                        { text: 'Alias', align: 'start', sortable: true, value: 'alias' },
                        { text: 'Email', align: 'start', sortable: true, value: 'email' },
                        { text: 'Ciudad', align: 'start', sortable: true, value: 'ciudad' },
                        { text: 'Vigente', align: 'center', sortable: false, value: 'estado' },
                        { text: 'Vendedor', align: 'center', sortable: false, value: 'vendedor' },
                        { text: 'Observacion', align: 'start', sortable: false, value: 'observa' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/entidad/Cliente/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            this.items.push({
                                'rut':element.Rut,
                                'nombre':element.Nombre,
                                'alias':element.Alias,
                                'email':element.Email,
                                'ciudad':element.Ciudad,
                                'estado':element.Estado,
                                'vendedor':element.Name_Vendor,
                                'observa':element.Observa
                            })
                        });
                    }                      
                    break
                  case 'Usuarios':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Login', align: 'start', sortable: true, value: 'login' },
                        { text: 'Nombre', align: 'start', sortable: true, value: 'nombre' },
                        { text: 'Email', align: 'start', sortable: true, value: 'email' },
                        { text: 'Comision', align: 'start', sortable: true, value: 'comision' },
                        { text: 'Bodega', align: 'start', sortable: true, value: 'local' },
                        { text: 'Vigente', align: 'center', sortable: false, value: 'estado' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/entidad/v4/Usuario/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            this.items.push({
                                'login':element.Usuario,
                                'nombre':element.Nombre,
                                'email':element.Email,
                                'comision':new Intl.NumberFormat("de-DE").format(parseFloat(element.Comision)),
                                'local':element.Local,
                                'estado':element.Estado
                            })
                        });
                    }                      
                    break
                    case 'Libro de Ventas':
                    this.headers=[];
                    this.items= [];
                    this.headers=[
                        { text: 'Fecha', align: 'center', sortable: true, value: 'fecha' },
                        { text: 'Documento', align: 'start', sortable: true, value: 'documento' },
                        { text: 'Numero', align: 'start', sortable: true, value: 'numero' },
                        { text: 'Neto', align: 'start', sortable: true, value: 'neto' },
                        { text: 'Iva', align: 'start', sortable: true, value: 'iva' },
                        { text: 'Total', align: 'start', sortable: false, value: 'total' },
                        { text: 'Pago', align: 'start', sortable: false, value: 'pago' },
                        { text: 'Sucursal', align: 'start', sortable: false, value: 'sucursal' },
                    ]
                    response = await axios.get(process.env.VUE_APP_URL + '/api/inv/report/libro/ventas/'+this.contrato+'/'+this.date1+'/'+this.date2);
                    datos=response.data;
                    if (datos[0].existe=='si'){
                        datos.forEach(element => {
                            this.items.push({
                                'fecha':element.Fecha,
                                'documento':element.Documento,
                                'numero':element.Numero,
                                'neto':new Intl.NumberFormat("de-DE").format(parseInt(element.Neto)),
                                'iva':new Intl.NumberFormat("de-DE").format(parseInt(element.Iva)),
                                'total':new Intl.NumberFormat("de-DE").format(parseInt(element.Total)),
                                'pago':element.Pago,
                                'sucursal':element.Sucursal
                            })
                        });
                    }                      
                    break
                };
                let varUsuario=this.usu;
                if (this.fullReport!==true){
                    this.itemsResult = this.items.filter(function(element){
                        return element.usuario==varUsuario;
                    });
                } else { this.itemsResult = this.items }
            } else {
                this.Msg='Seleccione tipo Reporte'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
            this.loading=false;
        },



 // funciones de reporteria
    async rptGanancias(){
        this.ganancias=[]
        await this.utilidad_final();
        if(this.ganancias.length!=0){
            await this.agrupaUtilidad();
            //filtramos por fechas solicitadas en totalgroup
            let filtro = this.totalgroup.filter(res => new Date(res.fecha+'T00:00:00')>=new Date(this.date1+'T00:00:00') &&  new Date(res.fecha+'T00:00:00')<=new Date(this.date2+'T00:00:00'));
            if(filtro){
                filtro.forEach(element => {
                    this.items.push({
                        'Fecha':element.fecha,
                        'Sku':element.sku,
                        'Producto':element.producto,
                        'Cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad)),
                        'PrecioCompra':new Intl.NumberFormat("de-DE").format(parseFloat(element.compra)),
                        'PrecioVenta':new Intl.NumberFormat("de-DE").format(parseFloat(element.venta)),
                        'Utilidad':new Intl.NumberFormat("de-DE").format(Math.round(parseFloat(element.utilidad))),
                        'Bodega':element.bodega,
                        'Origen':element.origen
                    })
                });
            }
        }
   },
    async utilidad_final(){
      try { 
        this.ganancias=[];
        const res = await axios.get(process.env.VUE_APP_URL + '/api/inv/movimientos/productos/utilidad/v1/'+this.contrato);
        const dato=res.data;
        if(dato.length!=0){
          this.movimientos=dato;
          // una vez obtenidos todos los movimientos
          // buscarmos todos los SKU  
          const res1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/utilidad/sku/all/'+ this.contrato);
          const dato1=res1.data;
          if(dato1.length!=0){
            this.productos=dato1;
            //await this.oneSku('LB00002');
            //comenzamos el recorrido por sku
            for (let index = 0; index < this.productos.length; index++) {
              const element = this.productos[index];
              await this.oneSku(element.Sku);
            }
          }
        };
        //console.log(this.ganancias);
      } catch (error) {
        console.log(error)
      }
    },
    async oneSku(tSku){
      var nSaldo=0;
      var nCompras=0;
      var nVentas=0;
      var nUtilidad=0;
      var nPrecio=0;
      var arraycompras=[];
      var puntero=0;
      var arrayutilidad=[];
      const arrayIN = this.movimientos.filter(res => res.Sku==tSku);
      if(arrayIN){
        arraycompras.push({
          'sku':'sku',
          'valor':'0',
          'unidades':'0'
        });
        for (let index = 0; index < arrayIN.length; index++) {
          const result = arrayIN[index];
          if(result.Sku=='ALIP-C001'){ console.log(nSaldo) };
          switch (result.Movimiento) {
            case 'Ingreso':
              nSaldo=parseFloat(nSaldo)+parseFloat(result.Cantidad);
              break;
            case 'Egreso':
              nSaldo=parseFloat(nSaldo)-parseFloat(result.Cantidad);
              break;
            case 'Reciclaje':
              nSaldo=parseFloat(nSaldo)-parseFloat(result.Cantidad);
              break;
            case 'Compra':
              // llenamos el array de compras
              arraycompras.push({
                'fecha':result.Fecha,
                'sku':result.Sku,
                'valor':result.Precio,
                'unidades':result.Cantidad
              });
              break;
            case 'Venta':
              if(parseFloat(result.Cantidad)<=parseFloat(nSaldo)){
                nVentas=parseFloat(result.Precio)*parseFloat(result.Cantidad);
                nCompras=parseFloat(nPrecio)*parseFloat(result.Cantidad);
                nUtilidad=parseFloat(nVentas)-parseFloat(nCompras);
                arrayutilidad.push({
                  'fecha':result.Fecha,
                  'sku':result.Sku,
                  'producto':result.Producto,
                  'cantidad':parseFloat(result.Cantidad),
                  'compra':parseFloat(nPrecio),
                  'venta':parseFloat(result.Precio),
                  'utilidad':parseFloat(nUtilidad),
                  'bodega':result.Bodega,
                  'origen':result.Movimiento
                });
                nSaldo=parseFloat(nSaldo)-parseFloat(result.Cantidad);
              } else {
                //recorrer cantidad y verificar saldo vs precio
                let granel=result.Cantidad;
                for (let index = 0; index < parseFloat(result.Cantidad); index++) {
                  if (parseFloat(nSaldo)<=0 && arraycompras.length>(puntero+1)){
                    puntero++;
                    nSaldo=parseFloat(nSaldo)+parseFloat(arraycompras[puntero].unidades);
                    nPrecio=parseFloat(arraycompras[puntero].valor);
                  };
                  //granel
                  if(granel<1 && granel>0){
                    nVentas=parseFloat(result.Precio)*granel;
                    nCompras=parseFloat(nPrecio)*granel;
                    nUtilidad=parseFloat(nVentas)-parseFloat(nCompras);
                    arrayutilidad.push({
                    'fecha':result.Fecha,
                    'sku':result.Sku,
                    'producto':result.Producto,
                    'cantidad':parseFloat(granel),
                    'compra':parseFloat(nPrecio),
                    'venta':parseFloat(result.Precio),
                    'utilidad':parseFloat(nUtilidad),
                    'bodega':result.Bodega,
                    'origen':result.Movimiento
                    });
                    nSaldo=parseFloat(nSaldo)-parseFloat(granel);
                    granel=0;
                  } else {
                    nVentas=parseFloat(result.Precio)*1;
                    nCompras=parseFloat(nPrecio)*1;
                    nUtilidad=parseFloat(nVentas)-parseFloat(nCompras);
                    arrayutilidad.push({
                    'fecha':result.Fecha,
                    'sku':result.Sku,
                    'producto':result.Producto,
                    'cantidad':1,
                    'compra':parseFloat(nPrecio),
                    'venta':parseFloat(result.Precio),
                    'utilidad':parseFloat(nUtilidad),
                    'bodega':result.Bodega,
                    'origen':result.Movimiento
                    });
                    nSaldo=parseFloat(nSaldo)-1;
                    granel=parseFloat(granel)-1
                  };
                }
              }
            break;
            case 'Devolucion':
              nVentas=parseFloat(result.Precio)*parseFloat(result.Cantidad);
              nCompras=parseFloat(nPrecio)*parseFloat(result.Cantidad);
              nUtilidad=parseFloat(nVentas)-parseFloat(nCompras);
              nUtilidad=nUtilidad*-1;
              arrayutilidad.push({
                  'fecha':result.Fecha,
                  'sku':result.Sku,
                  'producto':result.Producto,
                  'cantidad':parseFloat(result.Cantidad),
                  'compra':parseFloat(nPrecio),
                  'venta':parseFloat(result.Precio),
                  'utilidad':parseFloat(nUtilidad),
                  'bodega':result.Bodega,
                  'origen':result.Movimiento
              });
              nSaldo=parseFloat(nSaldo)+parseFloat(result.Cantidad);
              break;
          };
        };
      };
      this.ganancias = this.ganancias.concat(arrayutilidad);
    },

    async agrupaUtilidad(){
        //Creamos un nuevo objeto donde vamos a almacenar por ciudades. 
        let nuevoObjeto = [];
        let indice=0;
        //Recorremos el arreglo 
        for (let index = 0; index < this.ganancias.length; index++) {
            const el = this.ganancias[index];
            //buscamos si existe el registro
            const found = nuevoObjeto.find(
                resp => 
                //new Date(resp.fecha+'T00:00:00')==new Date(el.fecha+'T00:00:00') && 
                resp.fecha==el.fecha && 
                resp.sku==el.sku &&
                resp.producto==el.producto &&
                parseFloat(resp.compra)==parseFloat(el.compra) &&
                parseFloat(resp.venta)==parseFloat(el.venta) &&
                resp.bodega==el.bodega &&
                resp.origen==el.origen
            );
            if(!found){
                // no existe en el nuevo objeto
                nuevoObjeto.push({
                  'id':indice,  
                  'fecha':el.fecha,
                  'sku':el.sku,
                  'producto':el.producto,
                  'cantidad':parseFloat(el.cantidad),
                  'compra':parseFloat(el.compra),
                  'venta':parseFloat(el.venta),
                  'utilidad':parseFloat(el.utilidad),
                  'bodega':el.bodega,
                  'origen':el.origen
                });
                indice++
            } else {
                // si existe necesitamos obtener el ID para modificar la cantidad
                nuevoObjeto[found.id].cantidad=parseFloat(nuevoObjeto[found.id].cantidad)+parseFloat(el.cantidad);
                nuevoObjeto[found.id].utilidad=parseFloat(nuevoObjeto[found.id].utilidad)+parseFloat(el.utilidad)
            }
            //console.log(nuevoObjeto);
        };
        this.totalgroup=nuevoObjeto;
    },











        async Util(){
            try {
                // obtenemos todos los sku
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/utilidad/sku/all/'+ this.contrato);
                const datos=response.data;
                if(datos.length!=0){
                this.codigos=datos;
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    const tMedida=await this.searchMedida(element.Sku);
                    this.medidas.push({
                        mSku:element.Sku,
                        mMedida:tMedida
                    })
                };
                //console.log(this.medidas);
                // obtenemos todos las entradas
                const response1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/utilidad/entradas/'+ this.contrato);
                const datos1=response1.data;
                if(datos1.length!=0){
                    this.entradas=datos1;
                    //console.log(this.entradas);
                };
                // obtenemos las salidas
                const response2 = await axios.get(process.env.VUE_APP_URL + '/api/inv/utilidad/salidas/'+ this.contrato);
                const datos2=response2.data;
                if(datos2.length!=0){
                    this.salidas=datos2;
                    //console.log(this.salidas);
                };
                let HoraInicio = new Date();
                console.log('INICIO');
                console.log(HoraInicio);
                //comenzamos el recorrido por sku
                let arraySalida=[];
                this.codigos.forEach(element => {
                    const nSku=element.Sku;
                    //rescatamos las entradas
                    const arrayIN = this.entradas.filter(res => res.Sku==nSku);
                    if(arrayIN){
                        // preparamos la entrada
                        let ini=0;
                        let fin=0;
                        let valor=0;
                        let arrayEntrada=[];
                        for (let index = 0; index < arrayIN.length; index++) {
                            const res = arrayIN[index];
                            ini=fin+1;
                            fin=fin+parseFloat(res.Cantidad);
                            valor=res.Precio;
                            arrayEntrada.push({
                                'sku':res.Sku,
                                'inicio':parseFloat(ini),
                                'final':parseFloat(fin),
                                'precio':parseFloat(valor)
                            });                
                        };
                        // recorremos las Salidas
                        const arrayOUT = this.salidas.filter(res => res.Sku==nSku);
                        if(arrayOUT){
                            let fec='';
                            let rango=0;
                            let precio_venta=0;
                            let precio_compra=0;
                            let utilidad=0;
                            for (let index = 0; index < arrayOUT.length; index++) {
                            const res1 = arrayOUT[index];
                            fec=res1.Fecha;
                            if(res1.Origen=='Venta' || res1.Origen=='Devolucion'){
                                precio_venta=parseFloat(res1.Precio);
                                let resto=parseFloat(res1.Cantidad);
                                for (let index = 0; index < res1.Cantidad; index++) {
                                    if(res1.Origen=='Venta'){
                                        rango=parseFloat(rango)+1;
                                        //buscar precio compra segun rango
                                        const found = arrayEntrada.find(res => rango>=res.inicio && rango<=res.final);
                                        if(found){ precio_compra=parseFloat(found.precio) };
                                        if(resto>=1){
                                            utilidad=parseFloat(precio_venta)-parseFloat(precio_compra);
                                        }
                                        else {
                                            utilidad=(parseFloat(precio_venta)*resto)-(parseFloat(precio_compra)*resto);
                                        }
                                    };
                                    if(res1.Origen=='Devolucion'){
                                        rango=parseFloat(rango)-1;
                                        //buscar precio compra segun rango
                                        const found = arrayEntrada.find(res => rango>=res.inicio && rango<=res.final);
                                        if(found){ precio_compra=parseFloat(found.precio) };
                                        if(resto>=1){
                                            utilidad=parseFloat(precio_compra)-parseFloat(precio_venta);
                                        }
                                        else {
                                            utilidad=(parseFloat(precio_compra)*resto)-(parseFloat(precio_venta)*resto);
                                        };
                                        // cambiar signo por devolucion
                                        precio_venta=parseFloat(precio_venta)*-1
                                    }             
                                    //array utilidad
                                    let cuanto=0;
                                    if(resto>=1){ 
                                        cuanto=1 
                                    } else {
                                        cuanto=resto
                                    };
                                    arraySalida.push({
                                        'Fecha':fec,
                                        'Sku': res1.Sku,
                                        'Producto':res1.Producto, 
                                        'Cantidad':cuanto, 
                                        'PrecioCompra':precio_compra,
                                        'PrecioVenta':precio_venta,
                                        'Utilidad':utilidad,
                                        'Bodega':res1.Bodega,
                                        'Origen':res1.Origen
                                    })
                                    resto=parseFloat(resto)-1;
                                }
                            };
                            if(res1.Origen=='Egreso'){
                                rango=parseFloat(rango)-parseFloat(res1.Cantidad);
                            }            
                        }
                    }
                    }
                });
                //filtrar la salida segun fechas
                let arraySpecial=[];
                let filtro = arraySalida.filter(res => new Date(res.Fecha+'T00:00:00')>=new Date(this.date1+'T00:00:00') &&  new Date(res.Fecha+'T00:00:00')<=new Date(this.date2+'T00:00:00'));
                if(filtro.length!=0){
                    // agrupar Fecha, Sku 
                    filtro.forEach(el => {
                        const found = arraySpecial.find(
                            resp => 
                            resp.Fecha==el.Fecha && 
                            resp.Sku==el.Sku &&
                            resp.PrecioCompra==el.PrecioCompra &&
                            resp.PrecioVenta==el.PrecioVenta &&
                            resp.Bodega==el.Bodega &&
                            resp.Origen==el.Origen
                        );
                        if(found){ 
                            // ya esta grabado
                        } else {
                            // agrupar y graba
                            let arrayFinal = filtro.filter(
                                rest => 
                                rest.Fecha==el.Fecha && 
                                rest.Sku==el.Sku &&
                                rest.PrecioCompra==el.PrecioCompra &&
                                rest.PrecioVenta==el.PrecioVenta &&
                                rest.Bodega==el.Bodega &&
                                rest.Origen==el.Origen
                            );
                            if(arrayFinal.length!=0){
                                let xSuma=0;
                                let xCantidad=0;
                                for (let index = 0; index < arrayFinal.length; index++) {
                                    const elem = arrayFinal[index];
                                    xSuma=parseFloat(xSuma)+parseFloat(elem.Utilidad);
                                    xCantidad=parseFloat(xCantidad)+parseFloat(elem.Cantidad);
                                };
                                let uMedida='Sin Medida';
                                const foundMedida = this.medidas.find(m => m.mSku==el.Sku);
                                if(foundMedida){ uMedida=foundMedida.mMedida };
                                arraySpecial.push({
                                    'Fecha':el.Fecha,
                                    'Sku': el.Sku,
                                    'Producto':el.Producto,
                                    'Cantidad':xCantidad,
                                    'PrecioCompra':el.PrecioCompra,
                                    'PrecioVenta':el.PrecioVenta,
                                    'Medida':uMedida,
                                    'Utilidad':xSuma,
                                    'Bodega':el.Bodega,
                                    'Origen':el.Origen
                                });
                            }
                        }   
                    })                    
                };
                //this.items=arraySalida;
                let arrayOK=[];
                arraySpecial.forEach(e => {
                    if(e.Medida!='UN'){
                        arrayOK.push({
                            'Fecha':e.Fecha,
                            'Sku': e.Sku,
                            'Producto':e.Producto,
                            'Cantidad':new Intl.NumberFormat("de-DE").format(parseFloat(e.Cantidad.toFixed(3))),
                            'PrecioCompra':new Intl.NumberFormat("de-DE").format(parseFloat(e.PrecioCompra)),
                            'PrecioVenta':new Intl.NumberFormat("de-DE").format(parseFloat(e.PrecioVenta)),
                            'Medida':e.Medida,
                            'Utilidad':new Intl.NumberFormat("de-DE").format(parseInt(e.Utilidad)),
                            'Bodega':e.Bodega,
                            'Origen':e.Origen
                        });                    
                    } else {
                        arrayOK.push({
                            'Fecha':e.Fecha,
                            'Sku': e.Sku,
                            'Producto':e.Producto,
                            'Cantidad':new Intl.NumberFormat("de-DE").format(parseInt(e.Cantidad)),
                            'PrecioCompra':new Intl.NumberFormat("de-DE").format(parseFloat(e.PrecioCompra)),
                            'PrecioVenta':new Intl.NumberFormat("de-DE").format(parseFloat(e.PrecioVenta)),
                            'Medida':e.Medida,
                            'Utilidad':new Intl.NumberFormat("de-DE").format(parseInt(e.Utilidad)),
                            'Bodega':e.Bodega,
                            'Origen':e.Origen
                        });                    
                    }
                });
                this.items=arrayOK;
                console.log('FIN');
                let now = new Date();
                console.log(now);
                };                
            } catch (error) {
                console.log(error)
            }
        },
        async searchMedida(mSku){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/unidad/medida/'+ this.contrato +'/'+ mSku);
                const datos=response.data;
                if (datos[0].existe=='si'){ 
                    return datos[0].Medida;
                } else { return 'Sin Medida' }
            } catch (error) {
                return 'Sin Medida'
            }
        },
        async imprimirPDF(line){
            console.log(line);
            if (parseInt(line.numero)!=0){
                try {
                    let myEmisor;
                    let myCliente;
                    let myDetalle=[];
                    let myTotales;
                    let myReferencia;
                    let myFechas;
                    let myDocumento;
                    let myDescuentos=[];
                    //emisor
                    const data_emisor = await this.search_emisor();
                    if(data_emisor.length!=0){
                        myEmisor = data_emisor[0];
                    };
                    //cliente
                    if(line.cliente!='Boleta DTE'){
                        const data_cliente = await this.search_data_cliente(line);
                        const data_cli = data_cliente[0];
                        if(data_cli.length!=0){
                            myCliente = {
                                "rut": data_cli.Rut,
                                "razon": data_cli.Nombre,
                                "giro": data_cli.Observacion,
                                "direccion": data_cli.Direccion,
                                "comuna": data_cli.Comuna,
                                "ciudad": data_cli.Ciudad,
                                "telefono" : data_cli.Telefono,
                                "email" : data_cli.Email
                            }
                        };
                    } else {
                        myCliente = {
                            "rut": '1-9',
                            "razon": 'Boleta DTE',
                            "giro": '',
                            "direccion": '',
                            "comuna": '',
                            "ciudad": '',
                            "telefono" : '',
                            "email" : ''
                        }
                    };
                    //detalle
                    const data_detail = await this.search_detail_dte(line);
                    console.log('detalle', data_detail)
                    data_detail.forEach(element => {
                        if(parseFloat(element.Cantidad)!=0){
                            myDetalle.push({
                                "sku": element.Sku,
                                "producto": element.Producto,
                                "precio": element.Precio,
                                "cantidad": element.Cantidad
                            })                        
                        }
                    });
                    //totales
                    const data_total_dte = await this.search_total_dte(line);
                    const data_total = data_total_dte[0];
                    myTotales = {
                        "neto": data_total.Neto,
                        "impuesto": '19', //this.impuesto
                        "iva": data_total.Iva,
                        "total": data_total.Total,
                    };
                    //referencias
                    myReferencia = {
                        "folio": '',
                        "fecha": '',
                        "tipo": '',
                        "razon": ''
                    };
                    //fechas
                    myFechas = {
                        "emision": this.fechaNacional(data_total.Fecha),
                        "vencimiento": this.fechaNacional(data_total.Vencimiento),
                    };
                    //documento
                    let documento='';
                    if(this.tipo=='Ventas'){ documento='NOTA DE VENTA' };
                    if(this.tipo=='Devoluciones'){ 
                        if(line.tipo=='Nota Credito') { documento='DEVOLUCIÓN VENTA'};
                        if(line.tipo=='Nota Debito') { documento='NOTA DE DÉBITO'} 
                    };
                    let office_venta = '';
                    if(this.tipo=='Ventas'){ office_venta = line.oficina };
                    myDocumento = {
                        "folio": line.numero,
                        "documento": documento,
                        "ted": '',
                        "sucursal": office_venta
                    };
                    //descuentos
                    data_detail.forEach(element => {
                        if(parseFloat(element.Descuento)!=0){
                            myDescuentos.push({
                                "sku": element.Sku,
                                "producto": element.Producto,
                                "precio": element.Precio,
                                "cantidad": element.Cantidad,
                                "descuento": element.Descuento,
                                "concepto": element.Concepto,
                            })
                        }
                    });
                    //verPDF
                    const array_PDF = {
                        "myEmisor" : myEmisor,
                        "myCliente" : myCliente,
                        "myDetalle" : myDetalle,
                        "myTotales" : myTotales,
                        "myReferencia" : myReferencia,
                        "myFechas" : myFechas,
                        "myDocumento" : myDocumento,
                        "myDescuentos": myDescuentos
                    };
                    console.log('parametros PDF', array_PDF)
                    await this.verPDF(array_PDF);
                } catch (error) {
                    console.log(error)
                }
            }
        },
        fechaNacional(fec){
            const dia = fec.substring(8,10);
            const mes = fec.substring(5,7);
            const anio = fec.substring(0,4);
            const hoy = dia + '-' + mes + '-' + anio;
            return hoy;
        },
        async search_emisor(){
            let result = [];
            try {
                // const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/search/emisor/dte/'+this.contrato);
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/emisor/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    //agregamos el logo al id
                    var img_logo = document.getElementById("logo_emisor")
                    img_logo.src = datos[0].Logo;
                    result = datos;
                    // datos.forEach(element => {
                    //     if(parseInt(element.Oficina) == parseInt(this.office)){
                    //         result = element;
                    //     }
                    // })                    
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async search_data_cliente(line){
            let result = [];
            try {
                const params = this.contrato + '/' + line.entidad;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/search/cliente/'+ params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    result = datos;
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async search_detail_dte(line){
            let result = [];
            try {
                let type_doc = '';
                let params = '';
                if(this.tipo=='Ventas'){ 
                    type_doc = 'V' ;
                    params = type_doc + '/' + this.contrato + '/' + line.orden + '/' + line.entidad;
                };
                if(this.tipo=='Devoluciones'){ 
                    type_doc = 'D' ;
                    params = type_doc + '/' + this.contrato + '/' + line.numero + '/' + line.entidad;
                };
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/orden/entidad/app3/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    result = datos;
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async search_total_dte(line){
            let result = [];
            try {
                const params = this.contrato + '/' + line.numero;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/one/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    result = datos;
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },

        async verPDF(array_PDF){
            let myEmisor = array_PDF.myEmisor;
            let myCliente = array_PDF.myCliente;
            let myDetalle = array_PDF.myDetalle;
            let myTotales = array_PDF.myTotales;
            let myReferencia = array_PDF.myReferencia;
            let myFechas = array_PDF.myFechas;
            let myDocumento = array_PDF.myDocumento;
            let myDescuentos = array_PDF.myDescuentos;
            const total_items = myDetalle.length;
            let base = 0
            if(this.sigla=='INV'){ base = 152 };
            if(this.sigla=='NDV'){ base = 112 };
            const ancho = 72;
            const largo = (parseInt(total_items) * 4) + parseInt(base);
            const hoja = [ancho,largo];
            const doc = new jsPDF('p', 'mm', hoja);
            //const image = fs.readFileSync('Clientes/TerraFirma/logoTerra.jpg');
            //doc.addImage(image, 'JPEG', 2, 7, 45, 20);
            //doc.setDrawColor(255,0,0);
            //grosor linea
            doc.setLineWidth(0.5);
            //horizontal lines
            doc.line(22, 5, 67, 5);
            doc.line(22, 25, 67, 25);
            //vertical lines
            doc.line(22, 5, 22, 25);
            doc.line(67, 5, 67, 25);

            //tipo de letra bold = negrita y normal = normal
            doc.setFont("Helvetica", "bold");
            //tamaño de letra
            doc.setFontSize(10);
            //doc.setTextColor(255,0,0);
            //formateo de rut emisor
            var tmp 	= myEmisor.Rut.split('-');
		    var digv	= tmp[1]; 
		    var ruti 	= tmp[0];
            const format_rut = new Intl.NumberFormat("de-DE").format(ruti);
            const rut_emisor = ''+format_rut+'-'+digv;
            doc.text('R.U.T. : ' + (''+rut_emisor).toUpperCase(), 44.5, 10, { align: "center" });
            doc.text(myDocumento.documento, 44.5, 15, { align: "center" });
            doc.text('N° ' + myDocumento.folio, 44.5, 20, { align: "center" });

            if(this.sigla=='INV'){ 
                doc.text('S.I.I.' , 44.5, 28, { align: "center" });
            }
            
            doc.setLineWidth(0.2);
            doc.line(2, 32, 70, 32);

            //datos emisor
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(9);

            const anchoRazon = 70;
            let space_line = 3;
            let line = 37;
            let suma_line = 0;
            
            const razon_emisor = myEmisor.Razon_Social;
            const parrafo_razon = doc.splitTextToSize((''+razon_emisor).toUpperCase(), anchoRazon);
            doc.text(parrafo_razon, 36, line, {align: 'center',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_razon.length) * space_line;
            line = line + suma_line + space_line;

            const anchoEmisor = 60;
            space_line = 2

            doc.setFont("Helvetica", "normal");
            doc.setFontSize(7);

            doc.text('GIRO: ', 2, line);
            const giro_emisor = myEmisor.Giro;
            const parrafo_giro = doc.splitTextToSize((''+giro_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_giro, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_giro.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('DIRECCIÓN: ', 2, line);
            const direccion_emisor = myEmisor.Direccion;
            const parrafo_direccion = doc.splitTextToSize((''+direccion_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_direccion, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_direccion.length) * space_line;
            line = line + suma_line + space_line;

            // doc.text('COMUNA: ', 2, line);
            // const comuna_emisor = myEmisor.Comuna;
            // doc.text((''+comuna_emisor).toUpperCase(), 17, line);

            doc.text('CIUDAD: ', 2, line);
            const ciudad_emisor = myEmisor.Ciudad
            doc.text((''+ciudad_emisor).toUpperCase(), 17, line);

            //sumar las lineas del parrafo
            suma_line = 2
            line = line + suma_line + space_line;
            
            doc.text('SUCURSAL: ', 2, line);
            const sucursal_emisor = myDocumento.sucursal;
            const parrafo_sucursal = doc.splitTextToSize((''+sucursal_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_sucursal, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = 0;
            line = line + suma_line + space_line;

            doc.setLineWidth(0.2);
            doc.line(2, line, 70, line);

            line = line + 4;

            //datos cliente

            doc.text('CLIENTE: ', 2, line);
            const razon_cliente = myCliente.razon;
            const parrafo_cliente = doc.splitTextToSize((''+razon_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_cliente, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_cliente.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('RUT: ', 2, line);
            const rut_cliente = myCliente.rut;
            const parrafo_rut = doc.splitTextToSize((''+rut_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_rut, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_rut.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('GIRO: ', 2, line);
            const giro_cliente = myCliente.giro;
            const parrafo_giro_cliente = doc.splitTextToSize((''+giro_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_giro_cliente, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_giro_cliente.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('DIRECCIÓN: ', 2, line);
            const direccion_cliente = myCliente.direccion;
            const comuna_cliente = myCliente.comuna;
            const ciudad_cliente = myCliente.ciudad;
            const direccion_compuesta_cliente = direccion_cliente + ', ' + comuna_cliente + ', ' + ciudad_cliente;
            const parrafo_direccion_cliente = doc.splitTextToSize((''+direccion_compuesta_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_direccion_cliente, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_direccion_cliente.length) * space_line;
            line = line + suma_line + space_line;
 
            doc.text('FECHA EMISION: ', 2, line);
            const emision_cliente = myFechas.emision;
            doc.text(emision_cliente, 23, line);

            doc.text('FECHA VCTO: ', 39, line);
            const vence_cliente = myFechas.vencimiento;
            doc.text(vence_cliente, 57, line);

            suma_line = 0;
            line = line + suma_line + space_line;

            // doc.text('FORMA DE PAGO: ', 2, line);
            // const pago_cliente = myPago[0].forma;
            // doc.text((''+pago_cliente).toUpperCase(), 21, line);

            // suma_line = 0;
            // line = line + suma_line + space_line;

            doc.line(2, line, 70, line);

            //detalle
            doc.setFontSize(7);
            //encabezado
            line = line + 2.5;
            doc.text('DESCRIPCION PRODUCTO', 2, line);
            line = line + 2.5;
            doc.text('CANT. X PRECIO', 2, line);
            doc.text('TOTAL', 60, line);
            line = line + 1;
            doc.line(2, line, 70, line);
            line = line + 1;
            let myDescuento = 'no';
            myDetalle.forEach(element => {
                line = line + 2;
                doc.text((''+element.producto).toUpperCase(), 2, line);
                line = line + 2.5;
                const format_valor = new Intl.NumberFormat("de-DE").format(parseFloat(element.precio));
                const format_cantidad = new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad));
                const precio_item = parseFloat(element.precio) * parseFloat(element.cantidad);
                const format_precio =new Intl.NumberFormat("de-DE").format(parseFloat(precio_item));
                doc.text((''+format_cantidad+' x $'+format_valor).toUpperCase(), 2, line);
                doc.text(('$'+format_precio).toUpperCase(), 70, line, {align: 'right'});
            });
            line = line + 1;
            doc.line(2, line, 70, line);
            //referencias
            if(parseInt(this.ntipoDte)==5){ // factura
                line = line + 2;
                doc.text('Referencia a otros documentos.', 2, line);
                line = line + 3;
                doc.text('TIPO DOCTO.', 2, line);
                doc.text('FOLIO.', 30, line);
                doc.text('FECHA', 50, line);
                line = line + 2.5;
                doc.text(myReferencia.tipo, 2, line);
                doc.text(myReferencia.folio, 30, line);
                doc.text(myReferencia.fecha, 50, line);
                line = line + 1;
                doc.line(2, line, 70, line);
            }; 
            //totales
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(8);
            line = line + 5;
            doc.text('MONTO NETO', 32, line);
            const format_neto = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.neto).toFixed(2));
            doc.text(format_neto, 70, line, {align: 'right'});
            line = line + 3.5;
            doc.text('IVA ('+myTotales.impuesto+'%)', 32, line);
            const format_iva = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.iva).toFixed(2));
            doc.text(format_iva, 70, line, {align: 'right'});
            line = line + 3.5;
            doc.text('TOTAL', 32, line);
            const format_total = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.total).toFixed(0));
            doc.text(format_total, 70, line, {align: 'right'});

            if(this.sigla=='INV'){
                //timbre
                doc.setFont("Helvetica", "NORMAL");
                doc.setFontSize(7);
                line = line + 3;
                await this.PDF417_graphic(myDescuento.ted);
                doc.addImage(this.timbre_PDF,'JPEG',5,line,60,28);

                line = line + 30;
                doc.text('Timbre Electrónico S.I.I.' , 36, line, { align: "center" });
                line = line + 3.5;
                doc.text('Res. 80 del 22-08-2014 Verifique Documento en www.sii.cl' , 36, line, { align: "center" });
                line = line + 3.5;
                doc.text('GRACIAS POR SU COMPRA' , 36, line, { align: "center" });
            };
            if(this.sigla=='NDV'){
                line = line + 10;
                let pie = '';
                if(this.tipo=='Ventas'){ pie='GRACIAS POR SU COMPRA' };
                if(this.tipo=='Devoluciones'){ pie='Este Documento no es valido como DTE' };                                        
                doc.text('' + pie , 36, line, { align: "center" });
            };

            //voucher de descuento
            if(myDescuentos.length!=0){
                line = line + 2;
                doc.text('Este documento adjunta voucher de descuentos' , 31, line, { align: "center" });
                //obtener el largo de los descuentos
                const base_dscto = 50;
                const largo_dscto = (parseInt(myDescuentos.length) * 4) + parseInt(base_dscto);
                const hoja_dscto = [ancho,largo_dscto];
                doc.addPage(hoja_dscto,'mm','p');

                doc.setFont("Helvetica", "bold");
                doc.setFontSize(10);
                doc.text('Voucher de Descuentos' , 31, 10, { align: "center" });
                doc.setFont("Helvetica", "NORMAL");
                doc.setFontSize(7);
                doc.text('Rut Emisor   : ' + (''+rut_emisor).toUpperCase(), 2, 17);
                doc.text('Razon Social : ' + (''+razon_emisor).toUpperCase(), 2, 20);
                doc.text('Fecha Dscto. : ' + emision_cliente, 50, 17);
                doc.text('Ref. Docto.  : ' + myDocumento.folio, 50, 20);
                line = 22;
                //encabezado
                doc.line(2, line, 70, line);
                line = line + 2;
                doc.text('P. ORIGINAL', 2, line);
                doc.text('DESCRIPCION PRODUCTO', 20, line);
                line = line + 2;
                doc.text('CANT. X DSCTO.', 2, line);
                doc.text('CONCEPTO DSCTO.', 20, line);
                doc.text('TOTAL', 62, line);
                line = line + 0.5;
                doc.line(2, line, 70, line);
                line = line + 0.5;
                let myTotalDscto = 0;
                myDescuentos.forEach(element => {
                    line = line + 2; 
                    const valor_original = parseFloat(element.precio) + parseFloat(element.descuento);
                    const format_original = new Intl.NumberFormat("de-DE").format(parseFloat(valor_original));
                    doc.text(('( $'+format_original+' )').toUpperCase(), 2, line);                  
                    doc.text((''+element.producto).toUpperCase(), 20, line);
                    line = line + 2;
                    const format_descuento = new Intl.NumberFormat("de-DE").format(parseFloat(element.descuento));
                    const format_cantidad = new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad));
                    const precio_item = parseFloat(element.descuento) * parseFloat(element.cantidad);
                    doc.text((''+format_cantidad+' x $'+format_descuento).toUpperCase(), 2, line);
                    doc.text((''+element.concepto).toUpperCase(), 20, line);
                    const format_precio =new Intl.NumberFormat("de-DE").format(parseFloat(precio_item));
                    doc.text(('$ -'+format_precio).toUpperCase(), 70, line, {align: 'right'});
                    myTotalDscto = parseFloat(myTotalDscto) + parseFloat(precio_item);
                });
                line = line + 1;
                doc.line(2, line, 70, line);
                line = line + 5;
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(8);
                doc.text('TOTAL', 31, line);
                const format_dscto = new Intl.NumberFormat("de-DE").format(parseFloat(myTotalDscto).toFixed(2));
                doc.text('$ -' + format_dscto, 70, line, {align: 'right'});
            };
            doc.output('dataurlnewwindow');

        },
        async PDF417_graphic(ted){
            if(ted!=null && ted!=''){
                this.timbre_PDF='';
                var data_code = ted;
                PDF417.init(data_code);           	
                var barcode = PDF417.getBarcodeArray();
                // block sizes (width and height) in pixels
                var bw = 2;
                var bh = 2;
                // create canvas element based on number of columns and rows in barcode
                const canvas = document.createElement("canvas");
                //const canvas = createCanvas(200, 200);
                canvas.width = bw * barcode['num_cols'];
                canvas.height = bh * barcode['num_rows'];
                const ctx = canvas.getContext('2d');
                // graph barcode elements
                var y = 0;
                // for each row
                for (var r = 0; r < barcode['num_rows']; ++r) {
                    var x = 0;
                    // for each column
                    for (var c = 0; c < barcode['num_cols']; ++c) {
                        if (barcode['bcode'][r][c] == 1) {                        
                            ctx.fillRect(x, y, bw, bh);
                        }
                        x += bw;
                    }
                    y += bh;
                };
                const resultado = canvas.toDataURL();
                if(resultado.substring(10)=='data:image'){
                    this.timbre_PDF=resultado;
                } else {
                    this.timbre_PDF= this.timbre_universal;
                }
            } else {
                this.timbre_PDF= this.timbre_universal;
            }
        },
        async cotizaPDF(item){
            console.log('line cotiza',item);
            try {
                const doc = new jsPDF('p', 'mm', 'letter');
                //doc.addPage('p','mm','letter')

                doc.setLineWidth(1);
                doc.setDrawColor("#042955");
                doc.line(0.5, 0.5, 216, 0.5);

                //emisor
                const data_emisor = await this.search_emisor();
                //logo emisor
                var img_log = document.getElementById("logo_emisor");
                doc.addImage(img_log,'PNG',2,2,50,35,'aliasEncima');

                //datos emisor
                const emisor = data_emisor[0];
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                doc.text(('' + emisor.Razon_Social).toUpperCase(), 80, 8);
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(10);
                doc.text('' + emisor.Rut, 80, 13);
                if(emisor.Giro.length >= 50){
                    doc.text('' + emisor.Giro, 80, 18, { maxWidth: 75 } );
                    doc.text('' + emisor.Direccion, 80, 27);
                    doc.text('' + emisor.Email, 80, 32);
                    doc.text('' + emisor.Telefono, 80, 37);
                } else {
                    doc.text('' + emisor.Giro, 80, 18);
                    doc.text('' + emisor.Direccion, 80, 23);
                    doc.text('' + emisor.Email, 80, 28);
                    doc.text('' + emisor.Telefono, 80, 33);
                };
                
                //numero cotiza
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                doc.setTextColor('#000');
                doc.text('N° COTIZACIÓN', 187, 18,{align: 'center'});
                doc.setTextColor(255,0,0); //color de la letra = rojo
                doc.text(('' + item.orden).toString(), 187, 25,{align: 'center'});

                doc.setLineWidth(1);
                doc.setDrawColor("#042955");
                doc.line(0.5, 40, 216, 40);

                //fecha
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(10);
                doc.text('FECHA:', 160, 45);                
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(11);
                doc.text('' + this.fechaNacional(item.fecha), 184, 45);

                //datos del cliente
                const data_cliente = await this.search_data_cliente(item);
                const client = data_cliente[0];
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(9);
                doc.text('DATOS DEL CLIENTE', 10, 50);
                doc.setLineWidth(0.8);
                doc.setDrawColor("#fe6501");
                doc.line(10, 51, 38, 51);

                doc.setTextColor('#000');
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                doc.text(('' + client.Nombre).toUpperCase(), 10, 57);
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(10);
                doc.text('RUT', 10, 63);
                doc.text('GIRO', 10, 68);
                doc.text('DIRECCIÓN', 10, 73);
                doc.text('EMAIL', 10, 78);
                doc.text('CONTACTO', 10, 83);
                doc.setFontSize(11);
                doc.text(': ' + client.Rut, 38, 63);
                doc.text(': ' + client.Observacion, 38, 68);
                doc.text(': ' + client.Direccion, 38, 73);
                doc.text(': ' + client.Email, 38, 78);
                doc.text(': ' + client.Contacto, 38, 83);
                
                //encabezado detalle
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");
                doc.setFontSize(9);
                doc.text('DETALLE SERVICIO / PRODUCTO', 10, 95);
                doc.setLineWidth(0.8);
                doc.setDrawColor("#fe6501");
                doc.line(10, 96, 54, 96);

                doc.setFillColor('#042955');
                doc.rect(10, 100, 198, 7, 'F'); 

                doc.setTextColor('#FFFFFF');
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(10);
                doc.text('SKU', 12, 104.5);
                doc.text('DESCRIPCIÓN', 45, 104.5);
                doc.text('CANT.', 150, 104.5);
                doc.text('PRECIO', 170, 104.5);
                doc.text('TOTAL', 190, 104.5);


                //detalle productos
                const items_detalle = await this.search_detail_dte(item);
                doc.setTextColor('#000');
                doc.setFont("Helvetica", "noramal");
                doc.setFontSize(10);
                let line=112;
                items_detalle.forEach(element => {
                    doc.text('' + element.Sku, 12, line);
                    doc.text('' + element.Producto, 45, line);
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)), 158, line,{align: 'right'});
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)), 180, line,{align: 'right'});
                    const total_line = parseFloat(element.Precio) * parseFloat(element.Cantidad);
                    doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(total_line)), 200, line,{align: 'right'});
                    line = line + 5;
                });

                //total
                line = line + 1
                doc.setFillColor('#042955');
                doc.rect(150, line, 58, 7, 'F');
                doc.setTextColor('#FFFFFF'); 
                doc.setFont("Helvetica", "bold");
                doc.setFontSize(12);
                line = line + 5
                doc.text('TOTAL:', 155, line);
                doc.text('$ ' + item.total, 202, line,{align: 'right'});

                //pie de pagina
                //doc.setTextColor('#f9f9f9'); 
                doc.setTextColor('#A9A9A9');
                doc.setFont("Helvetica", "italic");
                doc.setFontSize(8);
                doc.text(('' + emisor.Razon_Social).toUpperCase() + ' - ' + emisor.Email , 100, 270,{align: 'center'});

                doc.output('dataurlnewwindow')

            } catch (error) {
                console.log(error)
            }
        },

    }
}
</script>